module.exports = __webpack_public_path__ + "static/dailyneeds-5a47eed8e843dce0c00538ba7af551ef.jpg";